import { DetailTabs, PageHeader } from '@/components/common'
import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { AssignmentsTab } from '../components/geofence/AssignmentsTab'
import { CoverageTab } from '../components/geofence/CoverageTab'
import { FaceTab } from '../components/geofence/FaceTab'
import { PoliciesTab } from '../components/geofence/PoliciesTab'
import { PunchReviewTab } from '../components/geofence/PunchReviewTab'
import { SitesTab } from '../components/geofence/SitesTab'

/**
 * Geofenced attendance: where each site is, which sites count for whom, and what punches did.
 *
 * <p>Set up in the order of the tabs — a fence on each site, then policies, then who they apply
 * to — and check Coverage before tightening anything to Block.
 */
export function GeofencingPage() {
  const breadcrumb = useBreadcrumb()
  return (
    <div className="space-y-4">
      <PageHeader
        title="Geofencing & face"
        breadcrumb={breadcrumb}
        subtitle="Control where people may punch from, and check that it is really them."
      />
      <DetailTabs
        tabs={[
          { key: 'sites', label: '1. Sites', content: <SitesTab /> },
          { key: 'policies', label: '2. Policies', content: <PoliciesTab /> },
          { key: 'assignments', label: '3. Assignments', content: <AssignmentsTab /> },
          { key: 'coverage', label: 'Employee coverage', content: <CoverageTab /> },
          { key: 'face', label: 'Face registration', content: <FaceTab /> },
          { key: 'review', label: 'Punch review', content: <PunchReviewTab /> },
        ]}
      />
    </div>
  )
}
